module.exports = __webpack_public_path__ + "c29770d03d2e95e3ea5899d57c6cfeab.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/About/kitten.jpg
 ** module id = 1419
 ** module chunks = 0
 **/